import React from "react"
import DetailWrapper from "../../../containers/artist/DetailWrapper"

const ArtistDetail = ({ match, children }) => {
  const { slug } = match.params
  return <DetailWrapper slug={slug}>{children}</DetailWrapper>
}

export default ArtistDetail
